/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_StorybankInputs */

const en_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const de_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const fr_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const es_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const it_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const nl_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const pl_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const fi_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const da_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const sv_landing_tab_storybank = /** @type {(inputs: Landing_Tab_StorybankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

/**
* | output |
* | --- |
* | "Story Bank" |
*
* @param {Landing_Tab_StorybankInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_storybank = /** @type {((inputs?: Landing_Tab_StorybankInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_StorybankInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_storybank(inputs)
	if (locale === "fr") return fr_landing_tab_storybank(inputs)
	if (locale === "es") return es_landing_tab_storybank(inputs)
	if (locale === "it") return it_landing_tab_storybank(inputs)
	if (locale === "nl") return nl_landing_tab_storybank(inputs)
	if (locale === "pl") return pl_landing_tab_storybank(inputs)
	if (locale === "fi") return fi_landing_tab_storybank(inputs)
	if (locale === "da") return da_landing_tab_storybank(inputs)
	if (locale === "sv") return sv_landing_tab_storybank(inputs)
	return en_landing_tab_storybank(inputs)
});